module.exports = __webpack_public_path__ + "img/2025-03-12b_2.656a3a21.jpg";